import { t } from "i18next";
import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {t("header-title")}
                  <span></span>
                </h1>
                <p>
                  مهمتنا هي تقديم أفضل الحلول المحاسبية والمالية المبتكرة، لبناء
                  أنظمة جديرة بالثقة. نساعد الشركات والمؤسسات على إدارة مواردها
                  المالية بكفاءة عالية من خلال{" "}
                  <span style={{ display: "inline-block" }}> ERP برامج </span>
                  <span>متكاملة وتقارير دقيقة تدعم اتخاذ القرار</span>
                  <p>
                    نعمل على تطوير الجيل الجديد من أنظمة الحسابات الذكية التي
                    تسهّل متابعة العمليات المالية اليومية، وتدعم لنمو مستدام
                    لعملائنا
                  </p>
                </p>
                <a
                  href="#contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  جرب الأن
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
